module.exports = __webpack_public_path__ + "account/assets/left-arrow.2130295b.svg";